
<p-confirmDialog />

<div class="card">
  <div class="card-content">
    <!-- Stats cards row (shared stats-cards styles) -->
    <div class="stats-cards-row">
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ totalEmployeesCount }}</span>
          <span class="stats-card-label">Total Employees</span>
          <span class="stats-card-sublabel">All employees</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-users"></i></div>
      </div>
      <div class="stats-card stats-card--success">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ activeEmployeesCount }}</span>
          <span class="stats-card-label">Active</span>
          <span class="stats-card-sublabel">Currently active</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-check-circle"></i></div>
      </div>
      <div class="stats-card stats-card--danger">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ inactiveEmployeesCount }}</span>
          <span class="stats-card-label">Inactive</span>
          <span class="stats-card-sublabel">Not active</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-minus-circle"></i></div>
      </div>
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ totalRecords }}</span>
          <span class="stats-card-label">Showing</span>
          <span class="stats-card-sublabel">After filters</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-list"></i></div>
      </div>
    </div>

    <!-- Filter bar (search + Export Excel + Add Employee in app header via PageHeaderSearchActionService) -->
    <div class="filter-bar filter-bar-collapsible mb-4" [class.filter-bar-visible]="pageHeaderService.currentFiltersVisible">
      <div class="filter-bar-filters">
        <div class="filter-field">
          <label for="statusFilter" class="filter-label">Status</label>
          <p-select id="statusFilter" [(ngModel)]="selectedStatusFilter" (ngModelChange)="applySearch()"
            [options]="statusFilterOptions" optionLabel="label" optionValue="value" placeholder="All"
            [showClear]="true" [filter]="true" filterPlaceholder="Search status..."
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label for="roleFilter" class="filter-label">Role</label>
          <p-select id="roleFilter" [(ngModel)]="selectedRoleFilter" (ngModelChange)="applySearch()"
            [options]="roleOptions" optionLabel="label" optionValue="value" placeholder="All Roles"
            [showClear]="true" [filter]="true" filterPlaceholder="Search role..."
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label for="designationFilter" class="filter-label">Designation</label>
          <p-select id="designationFilter" [(ngModel)]="selectedDesignationFilter" (ngModelChange)="applySearch()"
            [options]="designationOptions" optionLabel="label" optionValue="value" placeholder="All Designations"
            [showClear]="true" [filter]="true" filterPlaceholder="Search designation..."
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label for="categoryFilter" class="filter-label">Category</label>
          <p-select id="categoryFilter" [(ngModel)]="selectedCategoryFilter" (ngModelChange)="applySearch()"
            [options]="categoryOptions" optionLabel="label" optionValue="value" placeholder="All Categories"
            [showClear]="true" [filter]="true" filterPlaceholder="Search category..."
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label for="serviceGroupFilter" class="filter-label">Service Group</label>
          <p-select id="serviceGroupFilter" [(ngModel)]="selectedServiceGroupFilter" (ngModelChange)="applySearch()"
            [options]="serviceGroupOptions" optionLabel="label" optionValue="value" placeholder="All Service Groups"
            [showClear]="true" [filter]="true" filterPlaceholder="Search service group..."
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
      </div>
      <div class="filter-bar-actions" *ngIf="hasActiveFilters()">
        <button type="button" class="btn-clear-filters" (click)="clearFilters()" title="Clear all filters">
          <i class="pi pi-filter-slash"></i>
        </button>
      </div>
    </div>

    <p-table [scrollable]="true" scrollHeight="flex" [value]="filteredEmployees" [loading]="loading" [paginator]="true"
      [alwaysShowPaginator]="false" [rows]="rows" [totalRecords]="totalRecords" [first]="first"
      [rowsPerPageOptions]="rowsPerPageOptions" [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} employees"
      [tableStyle]="{ 'min-width': '100%' }"
      [resizableColumns]="true"
      columnResizeMode="expand"
      styleClass="p-datatable employee-management-table no-column-lines resize-handles-visible">

      <ng-template pTemplate="header">
        <tr>
          <th pResizableColumn pSortableColumn="name">
            Name
            <p-sortIcon field="name" />
          </th>
          <th pResizableColumn pSortableColumn="email">
            Email
            <p-sortIcon field="email" />
          </th>
          <th pResizableColumn pSortableColumn="role">
            Role
            <p-sortIcon field="role" />
          </th>
          <th pResizableColumn pSortableColumn="designation">
            Designation
            <p-sortIcon field="designation" />
          </th>
          <th pResizableColumn pSortableColumn="category">
            Category
            <p-sortIcon field="category" />
          </th>
          <th pResizableColumn pSortableColumn="serviceGroupName">
            Service Group
            <p-sortIcon field="serviceGroupName" />
          </th>
          <th class="th-actions">Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-employee>
        <tr [class.row-inactive]="employee.isActive === false">
          <td class="td-truncate" [pTooltip]="employee.name || '-'" tooltipPosition="top">{{ employee.name || '-' }}</td>
          <td class="td-truncate" [pTooltip]="employee.email || '-'" tooltipPosition="top">{{ employee.email || '-' }}</td>
          <td class="td-truncate" [pTooltip]="getEmployeeRoleDisplay(employee)" tooltipPosition="top">{{ getEmployeeRoleDisplay(employee) }}</td>
          <td class="td-truncate" [pTooltip]="employee.designationName || '-'" tooltipPosition="top">{{ employee.designationName || '-' }}</td>
          <td class="td-truncate" [pTooltip]="employee.categoryName || '-'" tooltipPosition="top">{{ employee.categoryName || '-' }}</td>
          <td class="td-truncate" [pTooltip]="getServiceGroupDisplay(employee)" tooltipPosition="top">{{ getServiceGroupDisplay(employee) }}</td>
          <td class="table-cell-actions">
            <div class="table-actions-stack">
              <p-button
                [icon]="employee.isActive ? 'pi pi-check-circle' : 'pi pi-times-circle'"
                [severity]="employee.isActive ? 'success' : 'secondary'"
                [text]="true"
                (onClick)="toggleActiveStatus(employee)"
                size="small"
                [pTooltip]="employee.isActive ? 'Active' : 'Inactive'"
                tooltipPosition="top" />
              <p-button
                icon="pi pi-pencil"
                (onClick)="showEditDialog(employee)"
                [text]="true"
                severity="info"
                size="small"
                pTooltip="Edit"
                tooltipPosition="top" />
              <!-- Inactive only: a real leaver keeps their history and stays inactive, so this is
                   for clearing test or mistakenly-created records. The dialog lists what the
                   employee is referenced by before anything is removed. -->
              <p-button
                *ngIf="!employee.isActive && canDeleteEmployees"
                icon="pi pi-trash"
                (onClick)="confirmDelete(employee)"
                [text]="true"
                severity="danger"
                size="small"
                pTooltip="Delete permanently"
                tooltipPosition="top" />
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr class="table-empty-row">
          <td colspan="7" class="table-empty-cell">
            <div class="empty-state">
              <div class="empty-icon"><i class="pi pi-inbox"></i></div>
              <p class="empty-message">No employees found</p>
              <p class="empty-description">Update filters or add a new employee</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<app-employee-form-dialog
  [(visible)]="displayEmployeeFormDialog"
  [employee]="employeeToEdit"
  [hasOnboardingRecord]="editingEmployeeHasOnboarding"
  (saved)="onEmployeeSaved($event)"
  (cancel)="onEmployeeFormCancel()" />

<!-- Permanent delete: shows exactly what the employee is referenced by, so the user can judge
     rather than being met with a bare yes/no. Historical data blocks the delete outright. -->
<p-dialog
  [(visible)]="deleteDialogVisible"
  header="Delete Employee"
  [modal]="true"
  styleClass="dialog-md"
  [dismissableMask]="true"
  [closable]="true">

  <div class="form-dialog-form form-dialog-compact" *ngIf="deleteTarget">
    <div class="form-dialog-container">

      <div class="emp-delete-intro">
        Permanently delete <strong>{{ deleteTarget.employeeName }}</strong>?
      </div>

      <div class="emp-delete-loading" *ngIf="deleteRefsLoading">
        <i class="pi pi-spin pi-spinner"></i> Checking what references this employee...
      </div>

      <ng-container *ngIf="!deleteRefsLoading">
        <!-- Nothing references them: a test or mistaken record, safe to remove. -->
        <div class="emp-delete-clean" *ngIf="deleteTarget.references.length === 0">
          <i class="pi pi-check-circle"></i>
          Nothing in the system references this employee. Deleting removes the record only.
        </div>

        <div class="emp-delete-refs" *ngIf="deleteTarget.references.length > 0">
          <div class="emp-delete-refs-title">This employee is referenced by:</div>
          <div class="emp-delete-ref" *ngFor="let ref of deleteTarget.references"
               [class.emp-delete-ref--blocking]="ref.isHistorical">
            <i class="pi" [ngClass]="ref.isHistorical ? 'pi-exclamation-triangle' : 'pi-link'"></i>
            <span class="emp-delete-ref-label">{{ ref.label }}</span>
            <span class="emp-delete-ref-count">{{ ref.count }}</span>
          </div>
        </div>

        <div class="emp-delete-verdict emp-delete-verdict--blocked" *ngIf="!deleteTarget.canDeleteSafely">
          <i class="pi pi-ban"></i>
          <div>
            <strong>This employee cannot be deleted.</strong>
            The data above is business history and would be lost. Leaving them
            <strong>inactive</strong> already hides them from work logs, allocations and dropdowns
            while keeping their records intact.
          </div>
        </div>

        <div class="emp-delete-verdict emp-delete-verdict--warn" *ngIf="deleteTarget.canDeleteSafely">
          <i class="pi pi-exclamation-triangle"></i>
          <div>This cannot be undone. Role and service group links are removed with the employee.</div>
        </div>
      </ng-container>

    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="form-dialog-footer-btns">
      <p-button label="Cancel" icon="pi pi-times" (onClick)="deleteDialogVisible = false"
        severity="secondary" [outlined]="true" />
      <p-button label="Delete permanently" icon="pi pi-trash" (onClick)="performDelete()"
        severity="danger"
        [disabled]="deleteRefsLoading || !deleteTarget?.canDeleteSafely || deleting" />
    </div>
  </ng-template>
</p-dialog>
